export enum UserType {
    Private = 'Private',
    Business = 'Business',
}
